export const ToolbarIcon = ({ iconName, className = "w-6 h-6" }) => {
	const icons = {
		Download: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					d="M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z"
					fill="white"
				/>
			</svg>
		),
		SpotView: (
			<svg
				preserveAspectRatio="none"
				width="24"
				height="24"
				overflow="visible"
				style={{ display: "block" }}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="layout-grid-fill 1">
					<path
						id="Vector"
						d="M22 12.999V20C22 20.5523 21.5523 21 21 21H13V12.999H22ZM11 12.999V21H3C2.44772 21 2 20.5523 2 20V12.999H11ZM11 3V10.999H2V4C2 3.44772 2.44772 3 3 3H11ZM21 3C21.5523 3 22 3.44772 22 4V10.999H13V3H21Z"
						fill="white"
					/>
				</g>
			</svg>
		),
		CameraAngle1: (
			<svg
				preserveAspectRatio="none"
				width="24"
				height="24"
				overflow="visible"
				style={{ display: "block" }}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="Frame">
					<path
						id="Vector"
						d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"
						fill="white"
					/>
				</g>
			</svg>
		),
		CameraAngle2: (
			<svg
				preserveAspectRatio="none"
				width="24"
				height="24"
				overflow="visible"
				style={{ display: "block" }}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="Frame">
					<path
						id="Vector"
						d="M17 9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16C16.5523 4 17 4.44772 17 5V9.2Z"
						fill="white"
					/>
				</g>
			</svg>
		),
		CameraAngle3: (
			<svg
				preserveAspectRatio="none"
				width="24"
				height="24"
				overflow="visible"
				style={{ display: "block" }}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="Frame">
					<path
						id="Vector"
						d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"
						fill="white"
					/>
				</g>
			</svg>
		),
		ZoomIn: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM10 10H7V12H10V15H12V12H15V10H12V7H10V10Z"
					fill="white"
				/>
			</svg>
		),
		Play: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					d="M19.376 12.4161L8.77735 19.4818C8.54759 19.635 8.23715 19.5729 8.08397 19.3432C8.02922 19.261 8 19.1645 8 19.0658V4.93433C8 4.65818 8.22386 4.43433 8.5 4.43433C8.59871 4.43433 8.69522 4.46355 8.77735 4.5183L19.376 11.584C19.6057 11.7372 19.6678 12.0477 19.5146 12.2774C19.478 12.3323 19.4309 12.3795 19.376 12.4161Z"
					fill="white"
				/>
			</svg>
		),
		Pause: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className={className}
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M15.75 5.25v13.5m-6-13.5v13.5"
				/>
			</svg>
		),
		Restart: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className={className}
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M19.95 11a8 8 0 1 0-.5 4m.5 5v-5h-5"
				/>
			</svg>
		),
		Expand: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					d="M8 3V5H4V9H2V3H8ZM2 21V15H4V19H8V21H2ZM22 21H16V19H20V15H22V21ZM22 9H20V5H16V3H22V9Z"
					fill="white"
				/>
			</svg>
		),
		ArrowLeftRight: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className={className}
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M8.25 7.5l-3-3m0 0l3-3m-3 3h13.5M15.75 16.5l3 3m0 0l-3 3m3-3H5.25"
				/>
			</svg>
		),

		ZoomInAndOut: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="16"
				height="54"
				viewBox="0 0 16 54"
				fill="none"
			>
				{/* Plus icon (top) */}
				<path
					d="M7.33398 7.33325V3.33325H8.66732V7.33325H12.6673V8.66658H8.66732V12.6666H7.33398V8.66658H3.33398V7.33325H7.33398Z"
					fill="white"
				/>

				<rect x="7" y="18" width="2" height="18" rx="1" fill="#D9D9D9" />

				<path
					d="M3.33398 46.3333V47.6666H12.6673V46.3333H3.33398Z"
					fill="white"
				/>
			</svg>
		),

		LoadingCircle: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.4711 4.35129C10.9709 4.25139 11.4827 4.20003 11.9999 4.20003C12.1292 4.20003 12.2582 4.20324 12.3867 4.20961C14.3146 4.30525 16.144 5.11323 17.5153 6.48459C17.6982 6.66744 17.871 6.85843 18.0335 7.05672C19.1707 8.44469 19.7999 10.1899 19.7999 12C19.7999 14.0687 18.9781 16.0527 17.5153 17.5155C16.0526 18.9782 14.0686 19.8 11.9999 19.8C9.93122 19.8 7.94726 18.9783 6.48447 17.5155C5.02169 16.0527 4.19991 14.0687 4.1999 12C4.1999 11.4583 4.25626 10.9223 4.36574 10.4C4.67429 8.92795 5.40477 7.5643 6.48447 6.4846C7.58156 5.38751 8.97181 4.65098 10.4711 4.35129ZM2.68453 9.67972C2.52889 10.3045 2.43592 10.9458 2.40849 11.594C2.34964 12.9844 2.5936 14.3772 3.13066 15.6738C3.85726 17.428 5.08772 18.9273 6.66643 19.9821C8.24514 21.037 10.1012 21.6 11.9999 21.6C13.8986 21.6 15.7547 21.037 17.3334 19.9821C18.9121 18.9273 20.1425 17.428 20.8692 15.6738C21.3687 14.4678 21.6147 13.1786 21.5992 11.8855C21.5922 11.2977 21.5312 10.7091 21.4154 10.1272C21.1683 8.8847 20.679 7.70975 19.982 6.66656C19.9608 6.63481 19.9394 6.60318 19.9178 6.57168C19.5854 6.08685 19.2077 5.63136 18.7881 5.2118C18.7417 5.16536 18.6948 5.1194 18.6474 5.07393C18.2673 4.70912 17.8594 4.3777 17.4283 4.08213C16.8802 3.70638 16.2946 3.3886 15.6811 3.13386C15.5348 3.07313 15.3869 3.01597 15.2376 2.96248C14.7944 2.80369 14.3383 2.67709 13.8728 2.58449C12.6422 2.33973 11.3695 2.33735 10.127 2.58449C9.74146 2.66119 9.36239 2.7612 8.99173 2.8835"
					fill="#333333"
					fillOpacity="0.1"
				/>
				<path
					d="M11.9999 4.20003C9.93121 4.20003 7.94726 5.02182 6.48447 6.4846C5.02169 7.94738 4.1999 9.93134 4.1999 12C4.1999 12.2387 4.10508 12.4676 3.9363 12.6364C3.76752 12.8052 3.5386 12.9 3.2999 12.9C3.06121 12.9 2.83229 12.8052 2.66351 12.6364C2.49472 12.4676 2.3999 12.2387 2.3999 12C2.3999 10.1013 2.96293 8.24527 4.01779 6.66656C5.07266 5.08785 6.57197 3.85739 8.32614 3.13079C10.0803 2.40419 12.0106 2.21407 13.8728 2.58449C15.735 2.95491 17.4455 3.86922 18.7881 5.2118C20.1307 6.55439 21.045 8.26494 21.4154 10.1272C21.7859 11.9894 21.5958 13.9196 20.8692 15.6738C20.1425 17.428 18.9121 18.9273 17.3334 19.9821C15.7547 21.037 13.8986 21.6 11.9999 21.6C11.7612 21.6 11.5323 21.5052 11.3635 21.3364C11.1947 21.1676 11.0999 20.9387 11.0999 20.7C11.0999 20.4613 11.1947 20.2324 11.3635 20.0636C11.5323 19.8949 11.7612 19.8 11.9999 19.8C14.0686 19.8 16.0526 18.9782 17.5153 17.5155C18.9781 16.0527 19.7999 14.0687 19.7999 12C19.7999 9.93134 18.9781 7.94738 17.5153 6.48459C16.0526 5.02181 14.0686 4.20003 11.9999 4.20003Z"
					fill="#6D6D6D"
				/>
			</svg>
		),
	};

	return icons[iconName] || null;
};
